import { useAppSelector } from 'app/hooks';
import { ChildSubMenuGroup } from 'features/MenuBook/models';
import { memo } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import ChildSubMenuRow from '../ChildSubMenuRow';
import { getListStyle } from '../MenuBookEditorModal';

export interface ChildSubMenuRowListProps {
  genreId: number;
  subgenreId: number;
  menuId: number;
  subMenuGroupId: number;
  subMenuId: number;
  childSubMenuGroupId: number;
}

function ChildSubMenuRowList({
  genreId,
  subgenreId,
  menuId,
  subMenuGroupId,
  subMenuId,
  childSubMenuGroupId,
}: ChildSubMenuRowListProps) {
  const childSubMenuGroup = useAppSelector((state) => {
    return state.menuBookEditor.data
      .flatMap((genre) => (genre.id === genreId ? genre.subgenres : []))
      .flatMap((subgenre) => (subgenre.id === subgenreId ? subgenre.menus : []))
      .flatMap((menu) => (menu.id === menuId ? menu.sub_menu_groups : []))
      .flatMap((subMenuGroup) => (subMenuGroup.id === subMenuGroupId ? subMenuGroup.sub_menus : []))
      .flatMap((subMenu) => (subMenu.id === subMenuId ? subMenu.child_sub_menu_groups : []))
      .find((childSubMenuGroup) => childSubMenuGroup.id === childSubMenuGroupId);
  }) as ChildSubMenuGroup;

  const pathId = `${genreId}-${subgenreId}-${menuId}-${subMenuGroupId}-${subMenuId}-${childSubMenuGroup.id}`;

  return (
    <Droppable droppableId={`child_sub_menu_group-${pathId}`} type={`child_sub_menu-${pathId}`}>
      {(provided, snapshot) => (
        <div {...provided.droppableProps} ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
          {childSubMenuGroup.child_sub_menus.map((childSubMenu, index) => (
            <ChildSubMenuRow
              key={`child_sub_menu-${pathId}-${childSubMenu.id}`}
              genreId={genreId}
              subgenreId={subgenreId}
              menuId={menuId}
              subMenuGroupId={subMenuGroupId}
              subMenuId={subMenuId}
              childSubMenuGroupId={childSubMenuGroupId}
              childSubMenuId={childSubMenu.id}
              index={index}
            >
              {/* <ChildSubMenuGroupRowList
                genreId={genreId}
                subgenreId={subgenreId}
                menuId={menuId}
                subMenuGroupId={subMenuGroupId}
                subMenuId={childSubMenu.id}
              /> */}
            </ChildSubMenuRow>
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}

export default memo(ChildSubMenuRowList);
